import { apiBaseUrl } from '../config';

export interface WPPage {
  id: number;
  date: string;
  date_gmt: string;
  guid: {
    rendered: string;
  };
  modified: string;
  modified_gmt: string;
  slug: string;
  status: string;
  type: string;
  link: string;
  title: {
    rendered: string;
  };
  content: {
    rendered: string;
    protected: boolean;
  };
  excerpt: {
    rendered: string;
    protected: boolean;
  };
  author: number;
  featured_media: number;
  parent: number;
  menu_order: number;
  comment_status: string;
  ping_status: string;
  template: string;
  meta: any[];
  _links: any;
}

let pagesCache: WPPage[] | null = null;

export const fetchWordPressPages = async (): Promise<WPPage[]> => {
  if (pagesCache) {
    return pagesCache;
  }

  console.log('Fetching WordPress pages...');
  try {
    const response = await fetch(`${apiBaseUrl}/wp/v2/pages?per_page=100`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const pages = await response.json();
    console.log('Fetched pages:', pages);
    pagesCache = pages;
    return pages;
  } catch (error) {
    console.error('Error fetching WordPress pages:', error);
    return [];
  }
};

export const fetchWordPressPage = async (slug: string): Promise<WPPage | null> => {
  try {
    // Convert slug to lowercase for case-insensitive search
    const normalizedSlug = slug.toLowerCase();
    const response = await fetch(`${apiBaseUrl}/wp/v2/pages?slug=${normalizedSlug}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const pages = await response.json();
    return pages[0] || null;
  } catch (error) {
    console.error('Error fetching WordPress page:', error);
    return null;
  }
};

export interface PageMap {
  [key: string]: {
    title: string;
    path: string;
    isWordPress: boolean;
  };
}

let pageMapCache: PageMap | null = null;

export const initializePageMap = async (): Promise<PageMap> => {
  if (pageMapCache) {
    return pageMapCache;
  }

  try {
    const pages = await fetchWordPressPages();
    const map: PageMap = {};

    // Add WordPress pages to the map
    pages.forEach(page => {
      map[page.slug] = {
        title: page.title.rendered,
        path: `/${page.slug}`,
        isWordPress: true
      };
    });

    // Add local pages to the map
    map.home = {
      title: 'Home',
      path: '/',
      isWordPress: false
    };

    pageMapCache = map;
    return map;
  } catch (error) {
    console.error('Error initializing page map:', error);
    return {};
  }
};

export const getPageBySlug = (slug: string): PageMap[string] | undefined => pageMapCache?.[slug];

export const hasHomePage = (): boolean => !!pageMapCache?.home;

export const getHomePage = (): PageMap[string] | undefined => pageMapCache?.home; 